var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-shared-items",
    },
    [
      _vm.sharedElements.length > 0
        ? _c("h2", [_vm._v(_vm._s(_vm.$gettext("Geteilte Lernmaterialien")))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "cw-tiles",
        },
        _vm._l(_vm.sharedElements, function (element) {
          return _c(
            "li",
            {
              key: element.id,
              staticClass: "tile",
              class: [
                element.attributes.payload.color,
                _vm.sharedElements.length > 3 ? "" : "cw-tile-margin",
              ],
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.getSharedElementUrl(element.id),
                    title: element.attributes.title,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "preview-image",
                      class: [_vm.hasImage(element) ? "" : "default-image"],
                      style: _vm.getChildStyle(element),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "overlay-text",
                        },
                        [_vm._v(_vm._s(_vm.getOwnerName(element)))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description",
                    },
                    [
                      _c(
                        "header",
                        {
                          class: [
                            element.attributes.purpose !== ""
                              ? "description-icon-" + element.attributes.purpose
                              : "",
                          ],
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(element.attributes.title) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "description-text-wrapper",
                        },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(element.attributes.payload.description)
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "footer",
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.countChildren(element) + 1) +
                              "\n                        "
                          ),
                          _c(
                            "translate",
                            {
                              attrs: {
                                "translate-n": _vm.countChildren(element) + 1,
                                "translate-plural": "Seiten",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Seite\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }